export function unwrapCompanyMediaApiData(response) {
    if (!(response === null || response === void 0 ? void 0 : response.data) || !Object.prototype.hasOwnProperty.call(response.data, "data")) {
        throw new Error("Company Media API response missing data");
    }
    return response.data.data;
}
